import { Entity } from "@backstage/catalog-model";
import {
  useCurrentUser,
  useEntityCatalogSlug,
  useEntityRef,
} from "@internal/plugin-utilities";

export const useIssueDescriptionFormatted = (
  description: string,
  entity: Entity
) => {
  const user = useCurrentUser();
  const email = user?.spec?.profile?.email;
  const name = user?.metadata?.name;
  const displayName = user?.spec?.profile?.displayName;

  return {
    type: "doc",
    version: 1,
    content: [
      {
        type: "paragraph",
        content: [
          {
            text: description,
            type: "text",
          },
          {
            type: "hardBreak",
          },
          {
            type: "text",
            text: "------------------------------------------------------",
          },
          {
            type: "hardBreak",
          },
          {
            type: "text",
            text: `entityRef: ${useEntityRef({ entity })}`,
            marks: [
              {
                type: "link",
                attrs: {
                  href: `https://radiator.staging.kajabi.farm/${useEntityCatalogSlug(
                    { entity }
                  )}`,
                },
              },
            ],
          },
          {
            type: "hardBreak",
          },
          {
            type: "text",
            text: "Generated through Radiator",
            marks: [
              {
                type: "link",
                attrs: {
                  href: "https://radiator.staging.kajabi.farm",
                },
              },
            ],
          },
          {
            type: "text",
            text: " by ",
          },
          {
            type: "text",
            text: `@${displayName}`,
            marks: [
              {
                type: "link",
                attrs: {
                  href: `https://radiator.staging.kajabi.farm/default/user/${name}`,
                },
              },
            ],
          },
          {
            type: "text",
            text: " (",
          },
          {
            type: "text",
            text: email,
            marks: [
              {
                type: "link",
                attrs: {
                  href: `mailto:${email}`,
                },
              },
            ],
          },
          {
            type: "text",
            text: ")",
          },
        ],
      },
    ],
  };
};
